module.exports = __webpack_public_path__ + "img/12122663_1041201059255681_5477216592892381656_n.49ff0a04.jpg";